<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-flex align-items-center">
        <input
          type="text"
          class="form-control text-black rounded-0"
          placeholder="Search user"
          v-model="users.searchTerm"
        />
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <vue-good-table :columns="headers" :rows="rows">
        <!-- Empty state -->
        <template #emptystate>
          <center>Aucune entrées correspondantes trouvées</center>
        </template>
        <!-- Custom row -->
        <template #table-row="props">
          <span v-if="props.column.field === 'name'" class="text-nowrap">
            <b> {{ props.row.name }} </b>
          </span>
          <span v-else-if="props.column.field === 'phone'" class="text-nowrap">
            <b>{{ props.row.phone }}</b>
          </span>

          <span
            v-else-if="props.column.field === 'city_name'"
            class="text-nowrap"
          >
            {{ props.row.citie }}
          </span>

          <span
            v-else-if="props.column.field === 'created_at'"
            class="text-nowrap"
          >
            {{ getDate(props.row.created_at) }}
          </span>
          <span v-else-if="props.column.field === 'statut'">
            <div
              class="badge text-bg-success rounded-pill fs-13 me-5 mt-10"
              v-if="props.row.statut == 0"
            >
              Nouvelle
            </div>
            <div
              class="badge text-bg-warning rounded-pill fs-13 me-5 mt-10"
              v-else
            >
              Archivée
            </div>
          </span>

          <span v-else-if="props.column.field == 'actions'">
            <div class="dropdown">
              <button
                class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a
                    class="dropdown-item d-flex align-items-center"
                    :href="
                      `https://api.whatsapp.com/send?phone=` +
                      substrPhone(props.row.phone) +
                      `&amp;`
                    "
                  >
                    <i
                      class="ph ph-whatsapp-logo lh-1 me-8 position-relative top-1"
                    ></i>
                    Contacter
                  </a>
                </li>

                <li>
                  <button
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="archiveUser(props.row)"
                  >
                    <i
                      class="flaticon-delete lh-1 me-8 position-relative top-1"
                    ></i>
                    Archiver
                  </button>
                </li>
              </ul>
            </div>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="users"
        :offset="9"
        @paginate="fetchData"
      />
    </div>
  </div>
  <!-- <CreateNewUserModal /> -->
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import moment from "moment";
import Swal from "sweetalert2";
import { defineComponent, onMounted, reactive, ref } from "vue";
// import PaginatorContent from "@/components/PaginatorContent.vue";

export default defineComponent({
  name: "NewDrivers",
  components: {
    // CreateNewUserModal,
  },
  setup: () => {
    const { showToast } = useAppToast();

    const headers = [
      {
        label: "Nom",
        field: "name",
      },
      {
        label: "Numéro Téléphone",
        field: "phone",
      },
      {
        label: "Email",
        field: "email",
      },
      {
        label: "Ville",
        field: "city_name",
      },
      {
        label: "Message",
        field: "message",
      },
      {
        label: "Date",
        field: "created_at",
      },
      {
        label: "Statut",
        field: "statut",
      },
      {
        label: "Action",
        field: "actions",
      },
    ];

    const rows = ref([]);
    const loading = ref(false);

    const auth = useAuthStore();
    const user = auth.user;

    const users = reactive({
      searchTerm: "",
      searchCity: "",
      searchStatut: "",
      searchName: "",
      searchSDate: "",
      searchEDate: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    // Fetch data from API
    const fetchData = async (page = 1) => {
      loading.value = true;
      users.current_page = page;

      try {
        const res = await api.get(`/api/auth/liv_request_list`, {
          params: {
            searchTerm: users.searchTerm,
            searchName: users.searchName,
            searchCity: users.searchCity,
            searchStatut: users.searchStatut,
            searchSDate: users.searchSDate,
            searchEDate: users.searchEDate,

            page: users.current_page,
            per_page: users.per_page,
          },
        });

        rows.value = res.data.users.data;
        Object.assign(users, res.data.users);
      } catch (err) {
        console.error(err);
      } finally {
        loading.value = false;
      }
    };

    onMounted(async () => {
      fetchData();
    });

    function getDate(value: any) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }

    async function toggleAdActive(row) {
      Swal.fire({
        text: "Vous voulez désactiver ce compte ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, désactiver!",
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          const res = await api.post(`/api/auth/user_active/${row.id}`, {
            active: Number(!row.active),
          });
          if (res.data.message == "success") {
            fetchData();
            showToast("Utilisateur est bien modifé", "success");
          }
        } else if (result.isDenied) {
          // const item = rows.value.find((z) => z.id === row.id);
          // if(item){
          //   item.active = row.active;
          // }
        }
      });
    }

    async function openEdit(id) {
      // Logic to open edit modal or navigate to edit page
      console.log("Edit user with ID:", id);
      // For example, navigate to edit page
      window.location.href = `/edit-user/${id}`;
    }

    function substrPhone(val) {
      if (val && val != "" && val != null) {
        let phone = "";
        if (val.substring(0, 4) == "+212" && val.length == 13) {
          return val;
        }
        if (val.substring(0, 3) == "212" && val.length == 12) {
          phone = `+${val}`;
          return phone;
        }
        if (val.substring(0, 1) == "0" && val.length == 10) {
          phone = `212${val}`;
          return phone;
        }
        if (
          val.substring(0, 1) == "6" ||
          (val.substring(0, 1) == "7" && val.length == 9)
        ) {
          phone = `212${val}`;
          return phone;
        }
      } else {
        return val;
      }

      // return val.substring(0,x);
    }

    async function archiveUser(row) {
      const data = new FormData();
      data.append("request_id", row.id);
      data.append("user_id", user?.id);

      Swal.fire({
        text: "Vous voulez archiver cette demande ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui",
        cancelButtonText: "Non",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const res = await api.post(`/api/auth/archived_liv_request`, data);
            if (res.data.message === "success") {
              fetchData();
              showToast("Demande est bien archivée", "success"); // ✅ changed to success
            } else {
              showToast("Impossible d'archiver la demande", "error");
            }
          } catch (error) {
            showToast("Une erreur est survenue, veuillez réessayer", "error");
          }
        }
      });
    }

    return {
      rows,
      headers,
      fetchData,
      getDate,
      loading,
      users,
      toggleAdActive,
      openEdit,
      substrPhone,
      archiveUser,
    };
  },
});
</script>